import { useQueryClient } from "@tanstack/react-query";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createThreadMutation } from "@/app/Threads/GraphQL/threadMutations";
import { invalidateThreadQueries } from "@/app/Threads/utils/invalidateThreadQueries";

export function useCreateThread() {
  const queryClient = useQueryClient();

  return useGqlMutation(createThreadMutation, {
    // Not returned: the dialog closes on the new thread, and shouldn't wait for
    // the lists behind it.
    onSuccess: () => {
      invalidateThreadQueries(queryClient);
    },
  });
}
